import { objectHelper } from "@/_shared/utils";
import { useNotification } from "@/_shared/mixins";

const { createCopy } = objectHelper;
export const useMultipleDatepicker = {
  mixins: [useNotification],
  data() {
    return {
      shiftsGlobalTime: {
        start: '07:00',
        end: '19:00',
      },
    };
  },
  computed: {
    attributes() {
      return [
        {
          highlight: this.inputsWereDisabled ? 'gray' : 'blue',
          dates: this.form.dates,
        },
      ];
    },
    currentDate() {
      return new Date();
    },
  },
  methods: {
    saveGlobalTime(updatedTime, withAllShiftsRewriting) {
      if (withAllShiftsRewriting) {
        this.form.dates.forEach((date) => {
          this.form.times[date] = createCopy(updatedTime);
        });
        const message = 'Время всех смен перезаписано';
        this.showStandardNotification(message);
      }
      this.shiftsGlobalTime = updatedTime;
    },
    toggleDay(day) {
      if (day.isDisabled || this.inputsWereDisabled) {
        return;
      }
      const dateValue = day.id;
      const filteredDates = this.form.dates.filter((value) => (
        value !== dateValue
      ));

      if (filteredDates.length === this.form.dates.length) {
        this.form.dates.push(dateValue);
        return this.form.times = {
          ...this.form.times,
          [dateValue]: createCopy(this.shiftsGlobalTime),
        };
      }
      this.form.dates = filteredDates;

      const remainedTimes = {};
      for (const timeField in this.form.times) {
        const time = this.form.times[timeField];
        if (timeField !== dateValue) {
          remainedTimes[timeField] = time;
        }
      }
      this.form.times = remainedTimes;
    },
  },
};



// WEBPACK FOOTER //
// ./src/user/mixins/shifts-calendar/useMultipleDatepicker.js